import { render, staticRenderFns } from "./Service-2.vue?vue&type=template&id=2c1757c8&scoped=true&"
import script from "./Service-2.vue?vue&type=script&lang=js&"
export * from "./Service-2.vue?vue&type=script&lang=js&"
import style0 from "./Service-2.vue?vue&type=style&index=0&id=2c1757c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1757c8",
  null
  
)

export default component.exports